import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { beautyBaseUrl } from "network";

export const jobApply = createApi({
    reducerPath: "jobApply",
    baseQuery: fetchBaseQuery({
        baseUrl: beautyBaseUrl,
        credentials: "include",
        prepareHeaders: (headers, { getState }) => {
            const state = getState();
            const token = state.auth?.token;
            if (token) {
                console.log('token', token);
                headers.set("authorization", `Bearer ${token}`);
            } else {
                console.warn("Token not found in state.auth");
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        // ✅ Get All Categories
        getApplications: builder.query({
            query: ({ page = 1, limit = 100, search = "" }) => ({
                url: `/jobs?page=${page}&limit=${limit}&search=${search}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),


    }),
});

export const {
    useGetApplicationsQuery
} = jobApply;
